var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60576 19.9997C8.39552 20.0009 8.18711 19.9606 7.99248 19.8812C7.79785 19.8017 7.62082 19.6845 7.47155 19.5365C7.32182 19.388 7.20298 19.2113 7.12188 19.0166C7.04078 18.8219 6.99902 18.6131 6.99902 18.4023C6.99902 18.1914 7.04078 17.9826 7.12188 17.7879C7.20298 17.5932 7.32182 17.4166 7.47155 17.268L12.7592 12.0124L7.67923 6.72472C7.38169 6.42542 7.21469 6.02053 7.21469 5.5985C7.21469 5.17647 7.38169 4.77159 7.67923 4.47229C7.82773 4.32256 8.00441 4.20371 8.19908 4.12261C8.39375 4.04151 8.60255 3.99976 8.81343 3.99976C9.02432 3.99976 9.23312 4.04151 9.42778 4.12261C9.62245 4.20371 9.79913 4.32256 9.94764 4.47229L16.1139 10.8622C16.4066 11.1608 16.5705 11.5623 16.5705 11.9804C16.5705 12.3986 16.4066 12.8 16.1139 13.0986L9.72399 19.4885C9.58061 19.6434 9.40796 19.7683 9.21603 19.856C9.02409 19.9438 8.81668 19.9926 8.60576 19.9997Z",
    fill: "#4462EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightEnabled);
export default __webpack_public_path__ + "static/media/chevron-right-enabled.38ac57fc188f468a1e81e9fa4f952713.svg";
export { ForwardRef as ReactComponent };